{
  "period": "Period",
  "amount": "Amount",
  "details": "Details",
  "download": "Download"
}
